import { SET_DATA, type SetDataAction } from '../../../actions/app';
import type { ReportsOrderState } from './types';

type Action = SetDataAction;

const defaultState: ReportsOrderState = [];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ReportsOrderState = defaultState, action: Action): ReportsOrderState => {
	switch (action.type) {
		case SET_DATA:
			return action.payload.map((item) => item.reportKey);
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
